/**
 * Connection state of the live channel.
 *
 * Worth showing rather than hiding: every live surface in the app degrades to
 * REST-loaded data when the socket is down, and that failure is otherwise
 * invisible — the page looks fine, it just quietly stops updating. This says
 * which of the two you're looking at.
 */
export function LiveIndicator({
  connected,
  /** Live but silent — nominally running, no frames arriving. */
  stale,
  title,
}: {
  connected: boolean;
  stale?: boolean;
  title?: string;
}) {
  const state = !connected ? "off" : stale ? "stale" : "on";
  // "Live updates", not "Live": this reports whether the channel is connected,
  // and a bare "Live" sitting beside a session list reads as a claim that a
  // session is running — which it never was.
  const label =
    state === "off" ? "Offline" : state === "stale" ? "No signal" : "Live updates";
  return (
    <span
      className={`live-dot-wrap live-${state}`}
      title={
        title ??
        (state === "off"
          ? "Live channel disconnected — showing last loaded data"
          : state === "stale"
          ? "Connected, but no frames received recently"
          : "Connected to the live channel — new data arrives without a refresh")
      }
    >
      <span className="live-state-dot" aria-hidden="true" />
      {label}
    </span>
  );
}
